import ProjectsSVG from '../../assets/svg/projects.svg';
export default ProjectsSVG;
